import { defineComponent as _defineComponent } from 'vue'
import { Button, Typo } from '@travelata-libs/ui-kit';
  import { pluralize, useViewport } from '@travelata-libs/utils';
  import { computed, ref } from 'vue';
  import { CHECKOUT_REPEAT_CLICK_GUARD_MS, OFFERS_WORD_FORMS } from '../config';
  import { buildPartnerRedirectUrl } from '../lib/buildPartnerRedirectUrl';
  import useRoomProviders from '../lib/useRoomProviders';
  import { type ProviderOffer, type ProviderOfferData } from '../model/types';
  import PartnerRedirectModal from './PartnerRedirectModal.vue';
  import ProvidersTrustNote from './ProvidersTrustNote.vue';
  import RoomProviderItem from './RoomProviderItem.vue';

  interface RoomProvidersProps {
    offers: ProviderOffer[];
  }

  interface RoomProvidersEmits {
    (e: 'book'): void;
    (e: 'checkout', offer: ProviderOfferData): void;
    (e: 'offer-click', offer: ProviderOfferData): void;
    (e: 'modal-confirm', offer: ProviderOfferData): void;
    (e: 'modal-dismiss', offer: ProviderOfferData): void;
    (e: 'trust-tooltip-open'): void;
    (e: 'trust-tooltip-close'): void;
    (e: 'more-suppliers-open'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RoomProviders',
  props: {
    offers: null
  },
  emits: ["book", "checkout", "offer-click", "modal-confirm", "modal-dismiss", "trust-tooltip-open", "trust-tooltip-close", "more-suppliers-open"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'book'): void;
    (e: 'checkout', offer: ProviderOfferData): void;
    (e: 'offer-click', offer: ProviderOfferData): void;
    (e: 'modal-confirm', offer: ProviderOfferData): void;
    (e: 'modal-dismiss', offer: ProviderOfferData): void;
    (e: 'trust-tooltip-open'): void;
    (e: 'trust-tooltip-close'): void;
    (e: 'more-suppliers-open'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    offers: ProviderOffer[];
  }

  
  

  const { isMobile } = useViewport();

  const { providers, offersCountText } = useRoomProviders(() => props.offers);

  const COLLAPSED_VISIBLE_COUNT = 3;
  const isExpanded = ref<boolean>(false);

  const hasHiddenProviders = computed<boolean>(() => providers.value.length > COLLAPSED_VISIBLE_COUNT);
  const hiddenCount = computed<number>(() => Math.max(0, providers.value.length - COLLAPSED_VISIBLE_COUNT));
  const visibleProviders = computed(() =>
    hasHiddenProviders.value && !isExpanded.value ? providers.value.slice(0, COLLAPSED_VISIBLE_COUNT) : providers.value,
  );
  const toggleText = computed(() =>
    isExpanded.value ? 'Скрыть предложения' : `Показать ещё ${pluralize(OFFERS_WORD_FORMS, hiddenCount.value)}`,
  );

  const toggle = (): void => {
    isExpanded.value = !isExpanded.value;
    if (isExpanded.value) {
      emit('more-suppliers-open');
    }
  };

  const redirectOffer = ref<ProviderOfferData | null>(null);

  const onOfferBook = (offer: ProviderOfferData): void => {
    emit('offer-click', offer);
    emit('book');
  };

  let lastCheckoutAt = 0;

  const onOfferCheckout = (offer: ProviderOfferData): void => {
    const now = Date.now();
    // Двойной клик отправлял второй offer_click и второй запрос на создание заказа, пока шёл переход в чекаут
    if (now - lastCheckoutAt < CHECKOUT_REPEAT_CLICK_GUARD_MS) return;

    lastCheckoutAt = now;
    emit('checkout', offer);
  };

  const openRedirect = (offer: ProviderOfferData): void => {
    emit('offer-click', offer);
    redirectOffer.value = offer;
  };

  const cancelRedirect = (): void => {
    if (redirectOffer.value) {
      emit('modal-dismiss', redirectOffer.value);
    }
    redirectOffer.value = null;
  };

  const confirmRedirect = (): void => {
    const offer = redirectOffer.value;
    if (!offer) return;

    emit('modal-confirm', offer);

    if (offer.redirectUrl) {
      window.open(buildPartnerRedirectUrl(offer), '_blank', 'noopener');
    }

    redirectOffer.value = null;
  };

return { __sfc: true,props, emit, isMobile, providers, offersCountText, COLLAPSED_VISIBLE_COUNT, isExpanded, hasHiddenProviders, hiddenCount, visibleProviders, toggleText, toggle, redirectOffer, onOfferBook, lastCheckoutAt, onOfferCheckout, openRedirect, cancelRedirect, confirmRedirect, Button, Typo, PartnerRedirectModal, ProvidersTrustNote, RoomProviderItem }
}

})